import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Clients } from 'src/app/models/interfaces/clients';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Helps } from 'src/app/libs/helps';

@Component({
  selector: 'app-view-facility',
  templateUrl: './view-facility.component.html',
  styleUrls: ['./view-facility.component.css']
})
export class ViewFacilityComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private router: Router,
    private routeActive: ActivatedRoute,
    private helps: Helps
  ) { }

  level: number = 99;
  
  ngOnChanges(changes: SimpleChanges): void {
    var data = this.routeActive.snapshot.params;
    this.dataId = data['id'];
    this.level = this.helps.getToken()?.level;
    if (this.dataId > 0) {
      this.dataId;
      this.getClient(this.dataId);
    } else if ((data['id'] != null)) {
      this.getClient(data['id']);
    } else {
      this.router.navigate(['/control-ingreso/instalaciones/gestion']);
    }
  }

  ngOnInit(): void {
    console.log("LLEGO A BODEGA");
    var data = this.routeActive.snapshot.params;
    this.getFacility();
    this.dataId = data['id'];
    if (this.dataId > 0) {
      this.dataId;
      this.getClient(this.dataId);
    } else if ((data['id'] != null)) {
      this.getClient(data['id']);
    } else {
      this.router.navigate(['/control-ingreso/instalaciones/gestion']);
    }
  }

  facility: Facility;
  @Input()
  template: string;
  @Input()
  dataId: number = 0;

  @Input()
  modalRef: NgbModalRef | undefined;

  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Clients>();
  
  id: number = 0;
  active = 1;
  items: any;
  view: number = 1;
  
  // Nueva propiedad para controlar la vista activa
  activeView: string = 'control-ingreso';

  // Propiedad para controlar modo edición
  isEditing: boolean = false;
  
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(),
    owner: new UntypedFormControl(''),
    owner_phone: new UntypedFormControl(''),
    rut: new UntypedFormControl(''),
    turn: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    img_path: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
  });
  
  facilitys: Facility[];

  // Método para cambiar la vista activa
  setActiveView(view: string): void {
    this.activeView = view;
  }

  // Método para alternar modo edición
  toggleEdit(): void {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.form.enable();
    } else {
      this.form.disable();
      if (this.dataId > 0) {
        this.getClient(this.dataId);
      }
    }
  }

  // Método para guardar información de la instalación
  saveInfo(): void {
    if (this.form.valid) {
      this.api.updateFacility(this.form).subscribe(
        (response) => {
          this.toast.success('Instalación actualizada correctamente', 'Información');
          this.isEditing = false;
          this.form.disable();
          this.getClient(this.dataId);
        },
        (error) => {
          this.toast.error('Error al actualizar la instalación', 'Error');
        }
      );
    }
  }

  getClient(id: number) {
    this.api.getFacility(id).subscribe(
      (response) => {
        this.facility = response?.data as Facility;
        this.form.patchValue(response.data);
        this.form.disable();
      },
      (error) => {
        this.toast.warning('', 'Instalación no encontrada');
        this.router.navigate(['/control-ingreso/instalaciones/gestion']);
      }
    );
  }

  getFacility() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilitys = res.data as Facility[];
    });
  }

  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.form
        .get('rut')
        ?.setValue(rut);
    }
  }

  openModal(md: any, size = 'md') {
    this.modalRef = this.modal.open(md, {
      size: size,
    });
  }
  
}